import { defineStore } from "pinia";
import { ref } from "vue";
import * as authApi from "@/api/auth";

export const useAuthStore = defineStore("auth", () => {
  const user = ref(null);
  const ready = ref(false);

  async function refresh() {
    try {
      user.value = await authApi.me();
    } catch {
      user.value = null;
    } finally {
      ready.value = true;
    }
    return user.value;
  }

  async function login(email, password) {
    user.value = await authApi.login(email, password);
    ready.value = true;
    return user.value;
  }

  async function logout() {
    try { await authApi.logout(); } catch { /* ignore */ }
    user.value = null;
  }

  return { user, ready, refresh, login, logout };
});
